import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

const AboutPage = () => (
  <Layout>
    <SEO title="About" />
    <div>
      <section className="mb-6">
        <h2 className="text-5xl tracking-tight leading-none uppercase">
          About
        </h2>
      </section>
      <section className="my-2 p-4">
        <p className="mb-6 text-lg">
          I am an entrepreneur, technology leader and a software engineer.
        </p>

        <p className="mb-6 text-lg">
          I've worked with many companies across different industries to
          deliver the highest quality software with the most effective
          development teams. I've been engineer #1, scaling development teams
          through hiring, onboarding and mentoring. I've lead various projects
          through multiple generations through iterative processes. 
        </p>

        <p className="mb-6 text-lg">
          Across initiatives - I bring{" "}
          <strong className="font-bold">clarity</strong>,{" "}
          <strong className="font-bold">focus and execution</strong> -
          defining and driving the technology implementation and more
          importantly bringing team members together to effectively execute on
          the gameplan.
        </p>

        <p className="mb-6 text-lg">
          I lead by example and help others exceed in every aspect of
          technology, from devops to sales.
        </p>
        <p>Looking for a resume? <Link to={`/resume`} className="text-deeppink">Click here</Link>.</p>
      </section>
    </div>
  </Layout>
)

export default AboutPage
